import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { CheckProfile } from "../../store/slices/auth";
import Loader from "../../common/Loader";

// Function to fetch profile and check status
const fetchCheckProfile = async (dispatch, id) => {
  try {
    const data = await dispatch(CheckProfile({ profile_id: id })).unwrap();
    return Boolean(data?.user?.status);
  } catch (error) {
    console.log("Error checking profile status:", error.message);
    return false;
  }
};

const ProfileSetupRoute = () => {
  // status: null (loading), "UNAUTHENTICATED", "COMPLETE", "INCOMPLETE"
  const [status, setStatus] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkStatus = async () => {
      const user = Cookies.get("user");
      const lastActivity = localStorage.getItem("lastActivityTime");
      const INACTIVITY_LIMIT = 30 * 60 * 1000;

      if (!user || (lastActivity && Date.now() - parseInt(lastActivity, 10) > INACTIVITY_LIMIT)) {
        if (lastActivity && Date.now() - parseInt(lastActivity, 10) > INACTIVITY_LIMIT) {
          Cookies.remove("user");
          localStorage.removeItem("user");
        }
        setStatus("UNAUTHENTICATED");
        return;
      }

      try {
        const userData = JSON.parse(user);
        const profileId = userData?.profile_id;

        if (!profileId) {
          setStatus("UNAUTHENTICATED");
          return;
        }

        const isProfileComplete = await fetchCheckProfile(dispatch, profileId);
        if (isProfileComplete) {
          setStatus("COMPLETE");
        } else {
          setStatus("INCOMPLETE");
        }
      } catch (error) {
        console.error("Error checking profile status in ProfileSetupRoute:", error);
        setStatus("UNAUTHENTICATED");
      }
    };

    checkStatus();
  }, [dispatch]);

  if (status === null) {
    return <Loader />;
  }

  // If user is not logged in, send them to /login
  if (status === "UNAUTHENTICATED") {
    return <Navigate to="/login" replace />;
  }

  // If profile is already complete, redirect to dashboard
  if (status === "COMPLETE") {
    return <Navigate to="/" replace />;
  }

  // Profile is incomplete -> allow user to access setup pages
  return <Outlet />;
};

export default ProfileSetupRoute;
